<!--
 * @Author: cmchiu
 * @Date: 2023-05-25 14:05:55
 * @LastEditTime: 2023-05-31 09:37:46
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\TeacherProfile.vue
 * 
-->
<template>
    <div class="teacher-profile">
        <breadcrumb />

        <div class="layer-container">
            <h2 class="page-title">教師專業資訊</h2>
            <!-- Teacher Personal -->
            <div class="teacher-personal">
                <div class="teacher-personal__title d-flex align-items-center">
                    <img class="teacher-personal__icon" src="images/icon-personal.svg" width="30" height="31" alt="" />
                    <h3 class="teacher-personal__name" v-text="name"></h3>
                </div>
                <form id="teacher-personal__collapse" class="teacher-personal__collapse">
                    <ul class="teacher-personal__list">
                        <li class="teacher-personal__item">
                            現職
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 310px">姓名</th>
                                            <th style="width: 184px">分機</th>
                                            <th style="min-width: 80px">現職</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.basicdata" :key="index">
                                            <td v-text="row['姓名']"></td>
                                            <td v-text="row['分機']"></td>
                                            <td v-text="row['現職']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            學歷
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 600px">畢業學校科系</th>
                                            <th>教育程度</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.education" :key="index">
                                            <td v-text="row['畢業學校科系']"></td>
                                            <td v-text="row['教育程度']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            經歷
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 600px">服務單位</th>
                                            <th>職稱</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.workexperience" :key="index">
                                            <td v-text="row['服務單位']"></td>
                                            <td v-text="row['職稱']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            專長
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 100vw">專長</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.skill" :key="index">
                                            <td v-text="row['專長']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            專書
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px">年度</th>
                                            <th>專書</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.bookBC0001" :key="index">
                                            <td v-text="row['年度']"></td>
                                            <td v-text="row['專書']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            期刊論文
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px">年度</th>
                                            <th>期刊論文</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.bookBC0002" :key="index">
                                            <td v-text="row['年度']"></td>
                                            <td v-text="row['期刊論文']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            研討會論文
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px">年度</th>
                                            <th>研討會論文</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.bookBC0003" :key="index">
                                            <td v-text="row['年度']"></td>
                                            <td v-text="row['研討會論文']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            專利
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px">年度</th>
                                            <th>專利</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.bookBC0004" :key="index">
                                            <td v-text="row['年度']"></td>
                                            <td v-text="row['專利']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            展覽表演
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px">年度</th>
                                            <th style="width: 365px">展演主題</th>
                                            <th style="width: 101px">擔任職稱</th>
                                            <th style="width: 206px">主辦單位</th>
                                            <th>起日期</th>
                                            <th>迄日期</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.show" :key="index">
                                            <td v-text="row['年度']"></td>
                                            <td v-text="row['展演主題']"></td>
                                            <td v-text="row['擔任職稱']"></td>
                                            <td v-text="row['主辦單位']"></td>
                                            <td v-text="row['起日期']"></td>
                                            <td v-text="row['迄日期']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            設計創作
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px">年度</th>
                                            <th style="width: 302px">主題</th>
                                            <th style="width: 302px">作品名</th>
                                            <th style="width: 185px">出版者</th>
                                            <th>出版日期</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.desi" :key="index">
                                            <td v-text="row['年度']"></td>
                                            <td v-text="row['主題']"></td>
                                            <td v-text="row['作品名']"></td>
                                            <td v-text="row['出版者']"></td>
                                            <td v-text="row['出版日期']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            學術會議
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px">年度</th>
                                            <th style="width: 227px">會議名稱</th>
                                            <th style="width: 198px">主題</th>
                                            <th style="width: 123px">主辦單位</th>
                                            <th style="width: 103px">職務</th>
                                            <th>起日期</th>
                                            <th>迄日期</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.cfrn" :key="index">
                                            <td v-text="row['年度']"></td>
                                            <td v-text="row['會議名稱']"></td>
                                            <td v-text="row['主題']"></td>
                                            <td v-text="row['主辦單位']"></td>
                                            <td v-text="row['職務']"></td>
                                            <td v-text="row['起日期']"></td>
                                            <td v-text="row['迄日期']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            研究計畫
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px">年度</th>
                                            <th style="width: 502px">主題</th>
                                            <th style="width: 210px">補助單位</th>
                                            <th>起日期</th>
                                            <th>迄日期</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.rsrh" :key="index">
                                            <td v-text="row['年度']"></td>
                                            <td v-text="row['主題']"></td>
                                            <td v-text="row['補助單位']"></td>
                                            <td v-text="row['起日期']"></td>
                                            <td v-text="row['迄日期']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            榮譽獎賞
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px">年度</th>
                                            <th style="width: 515px">獎賞名稱</th>
                                            <th style="width: 317px">頒獎單位</th>
                                            <th>日期</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.priz" :key="index">
                                            <td v-text="row['年度']"></td>
                                            <td v-text="row['獎賞名稱']"></td>
                                            <td v-text="row['頒獎單位']"></td>
                                            <td v-text="row['日期']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            指導論文
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px">年度</th>
                                            <th style="width: 88px">學號</th>
                                            <th style="width: 78px">學生姓名</th>
                                            <th style="width: 452px">論文題目</th>
                                            <th style="width: 36px">學位</th>
                                            <th>起日期</th>
                                            <th>迄日期</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.inst" :key="index">
                                            <td v-text="row['年度']"></td>
                                            <td v-text="row['學號']"></td>
                                            <td v-text="row['學生姓名']"></td>
                                            <td v-text="row['論文題目']"></td>
                                            <td v-text="row['學位']"></td>
                                            <td v-text="row['起日期']"></td>
                                            <td v-text="row['迄日期']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li class="teacher-personal__item">
                            授課資料
                            <input type="checkbox" name="collapse" class="teacher-personal__collapse-btn" />
                            <!-- 表格 -->
                            <div class="teacher-personal__collapse-table">
                                <table class="info-table">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px">年度</th>
                                            <th style="width: 40px">學期</th>
                                            <th style="width: 92px">開課系簡稱</th>
                                            <th style="width: 92px">開課系代號</th>
                                            <th style="width: 92px">開課年班組</th>
                                            <th style="width: 73px">科目代號</th>
                                            <th style="width: 37px">群組</th>
                                            <th style="width: 84px">教師代號</th>
                                            <th style="width: 70px">教師姓名</th>
                                            <th>科目中文</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in profile.tcdf" :key="index">
                                            <td v-text="row['學年']"></td>
                                            <td v-text="row['學期']"></td>
                                            <td v-text="row['開課系簡稱']"></td>
                                            <td v-text="row['開課系代號']"></td>
                                            <td v-text="row['開課年班組']"></td>
                                            <td v-text="row['科目代號']"></td>
                                            <td v-text="row['群組']"></td>
                                            <td v-text="row['教師代號']"></td>
                                            <td v-text="row['教師姓名']"></td>
                                            <td v-text="row['科目中文']"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                    </ul>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { getTeacherInfo } from '@/api/teacher'
import { breadcrumb } from '@c'

export default {
    name: 'teacherProfile',

    components: { breadcrumb },

    data() {
        return {
            configs: {
                loading: false,
            },
            acct: this.$route.query.acct,
            name: '',
            profile: {
                basicdata: [], //基本資料
                education: [], //學歷
                workexperience: [], //經歷
                skill: [], //專長
                bookBC0001: [], //專書
                bookBC0002: [], //期刊論文
                bookBC0003: [], //研討會論文
                bookBC0004: [], //專利
                show: [], //展覽表演
                desi: [], //設計創作
                cfrn: [], //學術會議
                rsrh: [], //研究計畫
                priz: [], //榮譽獎賞
                inst: [], //指導論文
                tcdf: [], //授課資料
            },
        }
    },

    created() {
        const vm = this
        vm.getTeacherInfo(vm.acct, 'basicdata').then(() => {
            vm.name = vm.profile.basicdata[0]['姓名']
        })
        vm.getTeacherInfo(vm.acct, 'education')
        vm.getTeacherInfo(vm.acct, 'workexperience')
        vm.getTeacherInfo(vm.acct, 'skill')
        vm.getTeacherInfo(vm.acct, 'bookBC0001')
        vm.getTeacherInfo(vm.acct, 'bookBC0002')
        vm.getTeacherInfo(vm.acct, 'bookBC0003')
        vm.getTeacherInfo(vm.acct, 'bookBC0004')
        vm.getTeacherInfo(vm.acct, 'show')
        vm.getTeacherInfo(vm.acct, 'desi')
        vm.getTeacherInfo(vm.acct, 'cfrn')
        vm.getTeacherInfo(vm.acct, 'rsrh')
        vm.getTeacherInfo(vm.acct, 'priz')
        vm.getTeacherInfo(vm.acct, 'inst')
        vm.getTeacherInfo(vm.acct, 'tcdf')
    },

    methods: {
        async getTeacherInfo(acct, kind) {
            const vm = this
            vm.configs.loading = true
            await getTeacherInfo({ acct, kind })
                .then(res => {
                    // handle success
                    vm.profile[kind] = res.Items
                })
                .catch(err => {
                    // handle error
                    vm.profile[kind] = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },
    },
}
</script>
